import React from 'react';
import Type from 'prop-types';
import { observer } from 'mobx-react-lite';
import { Link as RouterLink, useRouteMatch, useLocation } from 'react-router-dom';
import { Card, CardContent, Box, Link, Typography } from '@material-ui/core';
import { CircularBar } from 'components';
import { backNavigationStore } from 'stores';
import { getMainUrl } from 'utils/navigation';
import { ru } from 'locale';
import useStyles from './ScoreInfo.styles';

const ScoreInfo = observer(props => {
  const { score } = props;
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const classes = useStyles();
  const mainUrl = getMainUrl(path);
  backNavigationStore.setBackUrl(pathname);

  return (
    <Card square id="score-info">
      <Link classes={{ root: classes.link }} component={RouterLink} to={`${mainUrl}score`}>
        <CardContent className={classes.cardContent}>
          <CircularBar size={112} value={score} />
          <Box mt={2}>
            <Typography color="textSecondary" variant="overline" align="center">
              {ru.scoringScore}
            </Typography>
          </Box>
        </CardContent>
      </Link>
    </Card>
  );
});

ScoreInfo.propTypes = {
  score: Type.number.isRequired,
};

export default ScoreInfo;
